// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Zkxt0bmTxjoJHiSzcS7X {
  display: flex;
}
.Zkxt0bmTxjoJHiSzcS7X.OfmRAbvNZJgUWDL_Wk3_ {
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.Zkxt0bmTxjoJHiSzcS7X.OfmRAbvNZJgUWDL_Wk3_ .J99UcOfEfrCk2nkhxJMF {
  margin-top: 16px;
}
.Zkxt0bmTxjoJHiSzcS7X.vGi7jHFdnQzN56nJT2x8 {
  flex-direction: row;
  justify-content: start;
  align-items: center;
}
.Zkxt0bmTxjoJHiSzcS7X.vGi7jHFdnQzN56nJT2x8 .J99UcOfEfrCk2nkhxJMF {
  margin-left: 16px;
}
.Zkxt0bmTxjoJHiSzcS7X.vGi7jHFdnQzN56nJT2x8 .J99UcOfEfrCk2nkhxJMF span {
  cursor: pointer;
}
.hot1CVgkHVAlsZCbq5uc {
  position: relative;
}
.hot1CVgkHVAlsZCbq5uc .anticon {
  width: 30px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  position: absolute;
  left: 0;
  bottom: 0;
  background: #f7f8f9;
  border: 2px solid #ffffff;
  border-radius: 50%;
  color: #7b8593;
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/components/EditAvatar/index.module.less"],"names":[],"mappings":"AACA;EACE,aAAA;AAAF;AAEE;EACE,sBAAA;EACA,uBAAA;EACA,mBAAA;AAAJ;AACI;EACE,gBAAA;AACN;AAGE;EACE,mBAAA;EACA,sBAAA;EACA,mBAAA;AADJ;AAEI;EACE,iBAAA;AAAN;AADI;EAGI,eAAA;AACR;AAKA;EACE,kBAAA;AAHF;AAEA;EAGI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,OAAA;EACA,SAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;AAFJ","sourcesContent":["\n.container {\n  display: flex;\n\n  &.bottom {\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    & .colors {\n      margin-top: 16px;\n    }\n  }\n\n  &.right {\n    flex-direction: row;\n    justify-content: start;\n    align-items: center;\n    & .colors {\n      margin-left: 16px;\n      :global span {\n        cursor: pointer;\n      }\n    }\n  }\n}\n\n.avatar {\n  position: relative;\n  :global .anticon {\n    width: 30px;\n    height: 30px;\n    text-align: center;\n    line-height: 30px;\n    position: absolute;\n    left: 0;\n    bottom: 0;\n    background: #f7f8f9;\n    border: 2px solid #ffffff;\n    border-radius: 50%;\n    color: #7b8593;\n    cursor: pointer;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Zkxt0bmTxjoJHiSzcS7X`,
	"bottom": `OfmRAbvNZJgUWDL_Wk3_`,
	"colors": `J99UcOfEfrCk2nkhxJMF`,
	"right": `vGi7jHFdnQzN56nJT2x8`,
	"avatar": `hot1CVgkHVAlsZCbq5uc`
};
export default ___CSS_LOADER_EXPORT___;
